module.exports = __webpack_public_path__ + "img/om.e523f68.svg";